import { getWeb3Sender, getWeb3Reader } from "src/wallet-connection";
import BigNumber from "bignumber.js";
import { BASE18 } from "src/configs/constance";
import ABI from "src/contract-logic/abis/NFTExpeditionABI.json";
import { handleEmit } from "src/contract-logic/logic";

function getContractExpedition(contractAddress) {
  const web3Sender = getWeb3Sender();
  const web3Reader = getWeb3Reader();
  var contractReader = new web3Reader.eth.Contract(ABI, contractAddress);
  if (web3Sender) {
    var contractSender = new web3Sender.eth.Contract(ABI, contractAddress);
  }
  return {
    getSuccessRate: async (collectionId) => {
      const successRate = await contractReader.methods.getSuccessRate(collectionId).call();
      return successRate;
    },
    getHugeSuccessRate: async (collectionId) => {
      const hugeSuccessRate = await contractReader.methods.getHugeSuccessRate(collectionId).call();
      return hugeSuccessRate;
    },
    getAccruedExperience: async (collectionId) => {
      const accruedExperience = await contractReader.methods.getAccruedExperience(collectionId).call();
      return accruedExperience;
    },
    isDeployed: async (collectionId) => {
      const deploy = await contractReader.methods.isDeployed(collectionId).call();
      return deploy;
    },
    getCurrentDifficulty: async () => {
      const currentDifficulty = await contractReader.methods.getCurrentDifficulty().call();
      return currentDifficulty;
    },
    getDeployTimestamp: async (collectionId) => {
      const deployTimestamp = await contractReader.methods.getDeployTimestamp(collectionId).call();
      return parseInt(deployTimestamp);
    },
    getTokenOfOwnerBalance: async (address) => {
      const tokenOfOwnerBalance = await contractReader.methods.getTokenOfOwnerBalance(address).call();
      return parseInt(tokenOfOwnerBalance);
    },
    getTokenOfOwnerAtIndex: async (address, index) => {
      const tokenOfOwnerAtIndex = await contractReader.methods.getTokenOfOwnerBalance(address, index).call();
      return tokenOfOwnerAtIndex;
    },
    getExpeditionCount: async (rarity) => {
      const expeditionCount = await contractReader.methods.getExpeditionCount(rarity).call();
      return parseInt(expeditionCount);
    },
    deploy: async (dispatch, address, collectionId, buffWinrateTickets, buffExpTickets) => {
      const emit = contractSender.methods
        .deploy(collectionId, buffWinrateTickets, buffExpTickets)
        .send({ from: address });
      handleEmit(dispatch, emit, "Deploy");
      await emit;
    },
    abandon: async (dispatch, address, collectionId) => {
      const emit = contractSender.methods.abandon(collectionId).send({ from: address });
      handleEmit(dispatch, emit, "Abandon");
      const res = await emit;
      const expeditionAbandoned = res.events.ExpeditionAbandoned;
      return {
        reward: BigNumber(expeditionAbandoned.returnValues.reward).dividedBy(BASE18).toNumber(),
        exp: expeditionAbandoned.returnValues.experience,
        status: parseInt(expeditionAbandoned.returnValues.status),
      };
    },
    withdraw: async (dispatch, address, collectionId) => {
      const emit = contractSender.methods.withdraw(collectionId).send({ from: address });
      handleEmit(dispatch, emit, "Withdraw");
      const res = await emit;
      const expeditionCompleted = res.events.ExpeditionCompleted;
      return {
        reward: BigNumber(expeditionCompleted.returnValues.reward).dividedBy(BASE18).toNumber(),
        exp: expeditionCompleted.returnValues.experience,
        status: parseInt(expeditionCompleted.returnValues.status),
      };
    },
    getExpeditionDuration: async () => {
      const expeditionDuration = await contractReader.methods.getExpeditionDuration().call();
      return parseInt(expeditionDuration);
    },
    isOnDuty: async (collectionId) => {
      const isOnDuty = await contractReader.methods.isOnDuty(collectionId).call();
      return isOnDuty;
    },
    getExpeditionPrice: async () => {
      const expeditionPrice = await contractReader.methods.getExpeditionPrice().call();
      return BigNumber(expeditionPrice).dividedBy(BASE18).toNumber();
    },
    getSuccessPayout: async () => {
      const successPayout = await contractReader.methods.getSuccessPayout().call();
      return BigNumber(successPayout).dividedBy(BASE18).toNumber();
    },
    getHugeSuccessPayout: async () => {
      const hugeSuccessPayout = await contractReader.methods.getHugeSuccessPayout().call();
      return BigNumber(hugeSuccessPayout).dividedBy(BASE18).toNumber();
    },
    getMaxTicketSpend: async () => {
      const maxTicket = await contractReader.methods.maxTicketSpend().call();
      return parseInt(maxTicket);
    },
    getBuffWinRate: async (amount) => {
      const buffWinRate = await contractReader.methods.buffWinRate(amount).call();
      return parseInt(buffWinRate) / 100;
    },
  };
}

export default {
  ABI,
  getContractExpedition,
};
